export enum AssessmentOrigin {
  HubEducacional,
  GDA,
  Trilha,
}
